module.exports = __webpack_public_path__ + "img/Mail@2x.f5a84032.png";